/* eslint-disable no-console */

export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const shouldLogDebug = process.env.NODE_ENV !== 'production';

const log = (level: LogLevel, ...args: unknown[]) => {
  switch (level) {
    case 'debug':
      if (shouldLogDebug) {
        console.debug(...args);
      }
      break;
    case 'info':
      if (shouldLogDebug) {
        console.info(...args);
      }
      break;
    case 'warn':
      console.warn(...args);
      break;
    case 'error':
      console.error(...args);
      break;
  }
};

export const logger = {
  debug: (...args: unknown[]) => log('debug', ...args),
  info: (...args: unknown[]) => log('info', ...args),
  warn: (...args: unknown[]) => log('warn', ...args),
  error: (...args: unknown[]) => log('error', ...args),
};

export type Logger = typeof logger;
